import { environment } from './environments/environment';

const cdnBucket = environment.config.aws.cdnBucket;
const publicBucket = environment.config.aws.publicBucket;

export const configurations = {
    links: {
        defaultAvatar:
            'https://lh3.googleusercontent.com/-XdUIqdMkCWA/AAAAAAAAAAI/AAAAAAAAAAA/4252rscbv5M/photo.jpg',
        trackingUrl: 'https://leapest.aftership.com/'
    },
    images: {
        defaultImage: 'http://placehold.it/350x200',
        defaultImage1500x350: 'http://placehold.it/1500x350',
        dolphinLogo: `/${cdnBucket}/images/leapest-dolphin.png`,
        dolphinNameLogo: `/${cdnBucket}/images/leapest-dolphin-name.png`,
        xmlIcon: `/${cdnBucket}/images/xml-icon.png`,
        creditCardLogos: `/${cdnBucket}/images/credit-card-logos.png`,
        adyenBannerLeapest: `/${cdnBucket}/images/adyen-banner-leapest.png`,
        visaLogo: `/${publicBucket}/icons-credit-cards/visa_curved.png`,
        masterCardLogo: `/${publicBucket}/icons-credit-cards/mastercard_curved.png`,
        amexLogo: `/${publicBucket}/icons-credit-cards/american_express_curved_64px.png`,
        jcbLogo: `/${publicBucket}/icons-credit-cards/jcb.png`,
        ccDefaultLogo: `/${publicBucket}/icons-credit-cards/credit_card_grey.png`,
        ccErrorLogo: `/${publicBucket}/icons-credit-cards/credit_card_red.png`,
        ccBlackDefaultLogo: `/${publicBucket}/icons-credit-cards/credit_card_grey.png`,
        edcastLogo: `/${cdnBucket}/82x52-logo.png`,
        newDarkEdcastLogo: `/${cdnBucket}/images/edcast-markeplace-dark.png`,
        newWhiteEdcastLogo: `/${cdnBucket}/images/ed-marketplace-logo-white.png`,
        newColorEdcastLogo: `/${cdnBucket}/images/ed-marketplace-logo-color.png`,
    },
    nrLogin: {
        showInfoNotification: -1
    },
    validators: {
        email: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$',
        houseNumber: '[A-Za-z0-9,-. ]*',
        phoneNumber: '^[^a-zA-Z]+$',
        vatNumber: `^(ATU[0-9]{8}|BE0[0-9]{9}|BG[0-9]{9,10}|HR[0-9]{11}|CY[0-9]{8}L|CZ[0-9]{8,10}|DE[0-9]{9}|DK[0-9]{8}|EE[0-9]{9}|(EL|GR)[0-9]{9}|ES[A-Z][0-9]{7}(?:[0-9]|[A-Z])|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|GB([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|HU[0-9]{8}|IE[0-9]S[0-9]{5}L|IT[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|LV[0-9]{11}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SE[0-9]{12}|SI[0-9]{8}|SK[0-9]{10})$`,
        zipCode: '.+',
        gstRegistrationNumber: '^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$',
        panNumber: '[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}'
    },
    alerts: {
        persistInLocalStorage: true
    },
    reports: {
        voucher: {
            //  /api/ + voucher + /report/generate API should exist in Amber
            templates: [
                {
                    key: 'itpx-vouchers',
                    value: 'All Vouchers'
                },
                {
                    key: 'itpx-exam-vouchers',
                    value: 'Exam Vouchers'
                },
                {
                    key: 'itpx-consumption-vouchers',
                    value: 'All Consumption Vouchers'
                }
            ],
            buyerTemplates: [
                {
                    key: 'itpx-buyer-vouchers',
                    value: 'All Vouchers (Buyer)'
                },
                {
                    key: 'itpx-buyer-consumption-vouchers',
                    value: 'All Consumption Vouchers (Buyer)'
                }
            ]
        },
        agora: {
            //  /api/ + agora + /report/generate API should exist in Amber
            templates: [
                {
                    key: 'itpx-downpayment-customers',
                    value: 'All down payment customers'
                }
            ],
            buyerTemplates: [
                {
                    key: 'itpx-downpayment-customers',
                    value: 'All down payment customers'
                }
            ]
        }
    },
    europeanCountries: {
        AT: true,
        BE: true,
        BG: true,
        HR: true,
        CY: true,
        CZ: true,
        DK: true,
        EE: true,
        FI: true,
        FR: true,
        DE: true,
        GR: true,
        HU: true,
        IE: true,
        IT: true,
        LV: true,
        LT: true,
        LU: true,
        MT: true,
        NL: true,
        PL: true,
        PT: true,
        RO: true,
        SK: true,
        SI: true,
        ES: true,
        SE: true,
        GB: true
    }
};



// WEBPACK FOOTER //
// ./src/configurations.ts